import React from 'react';
import PropTypes from 'prop-types';

import { Text, Input, PhoneFormat } from '../index';

export const EmergencyForm = ({ data, onChange, errors, disabledForm }) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', rowGap: '10px' }}>
            <Text $bold $fontSize="18px">
                Emergency Contact
            </Text>
            <Input
                required
                id="emergencyContractNumber"
                label="Contact Number"
                placeholder="000-000-000"
                name="emergencyContractNumber"
                onChange={(e) => onChange(e)}
                value={data?.emergencyContractNumber}
                InputProps={{
                    inputComponent: PhoneFormat,
                }}
                $inputMaxWidth="400px"
                helperText={
                    errors.find((value) => value.property === 'emergencyContractNumber')?.message
                }
                disabled={disabledForm}
            />
            <Input
                required
                id="emergencyContractName"
                label="Contact Name"
                placeholder="Contact Name"
                name="emergencyContractName"
                onChange={(e) => onChange(e)}
                value={data?.emergencyContractName}
                $inputMaxWidth="400px"
                helperText={
                    errors.find((value) => value.property === 'emergencyContractName')?.message
                }
                disabled={disabledForm}
                max={50}
            />
            <Input
                required
                id="emergencyContractRelation"
                label="Relationship"
                placeholder="Sister"
                name="emergencyContractRelation"
                onChange={(e) => onChange(e)}
                value={data?.emergencyContractRelation}
                $inputMaxWidth="400px"
                helperText={
                    errors.find((value) => value.property === 'emergencyContractRelation')?.message
                }
                disabled={disabledForm}
                max={50}
            />
        </div>
    );
};

EmergencyForm.propTypes = {
    onChange: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    errors: PropTypes.arrayOf(PropTypes.object),
};
